import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { SchedulingAssistant, CalendarEventData } from 'owa-calendar-scheduling-assistant';
import {
    handleSchedulingAssistantSave,
    handleSchedulingAssistantDiscard,
} from 'owa-calendar-compose-form-actions';

export interface FullComposeSchedulingAssistantProps {
    className?: string;
    formId: string | null;
}

const FullComposeSchedulingAssistant: React.FunctionComponent<FullComposeSchedulingAssistantProps> = props => {
    const { className, formId } = props;

    const onDone = React.useCallback(
        (finalState: CalendarEventData, isAllDayEventExplicitlySet: boolean) => {
            handleSchedulingAssistantSave(formId, finalState, isAllDayEventExplicitlySet);
        },
        [formId]
    );

    const onDiscard = React.useCallback(() => {
        handleSchedulingAssistantDiscard(formId);
    }, [formId]);

    return <SchedulingAssistant className={className} onDone={onDone} onDiscard={onDiscard} />;
};

export default observer(FullComposeSchedulingAssistant);
